import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  en: {
    appName: "Hustlers KSA",
    slogan1: "Don't Stop the Hustle",
    slogan2: "Every request is an opportunity, and every offer is a beginning.",
    tagline: "Get what you need from trusted local businesses in your city.",
    sub: "Post your request, receive competitive offers from the best local merchants, and pick what suits you — with ease.",
    getStarted: "Get started",
    iAmCustomer: "Create a Request",
    iAmMerchant: "Join as Merchant",
    login: "Log in",
    signup: "Sign up",
    logout: "Log out",
    email: "Email",
    password: "Password",
    name: "Full name",
    phone: "Phone",
    businessName: "Business name",
    whatsapp: "WhatsApp number",
    description: "Description",
    city: "City",
    district: "District",
    selectDistrict: "Select district",
    category: "Category",
    categories: "Categories",
    activity: "Service type",
    selectActivity: "Select service type",
    activityFree: "Describe what you need (optional)",
    budget: "Budget (SAR)",
    deadline: "Deadline",
    photo: "Photo",
    optional: "Optional",
    submit: "Submit",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
    createRequest: "New request",
    newRequest: "Post a request",
    myRequests: "My requests",
    receivedOffers: "Offers received",
    noRequests: "You haven't posted any requests yet.",
    noOffers: "No offers yet — merchants will appear here soon.",
    noFeed: "No matching requests for your coverage right now.",
    matchedRequests: "New requests",
    myOffers: "My offers",
    sendOffer: "Send offer",
    submitOffer: "Submit offer",
    accepted: "Offer accepted",
    pending: "Pending",
    rejected: "Not selected",
    completed: "Completed",
    open: "Open",
    sent: "Request sent",
    offers_received: "Offers arrived",
    expired: "Expired",
    price: "Price",
    deliveryTime: "Delivery time",
    notes: "Notes",
    acceptOffer: "Accept offer",
    contactWhatsApp: "Contact on WhatsApp",
    requestDetails: "Request details",
    pendingApproval: "Your account is under review — we'll get back to you soon.",
    underReview: "Under review",
    admin: "Admin",
    dashboard: "Dashboard",
    home: "Home",
    profile: "Profile",
    customers: "Customers",
    merchants: "Merchants",
    requests: "Requests",
    offers: "Offers",
    orders: "Orders",
    commission: "Commission",
    approve: "Approve",
    reject: "Reject",
    markCompleted: "Mark completed",
    inProgress: "In progress",
    expectedCommission: "Expected commission",
    totalCommission: "Total commission",
    rate: "Rate (%)",
    update: "Update",
    selectCategories: "Select your service categories",
    maxTwoCategories: "Pick up to 2 categories for your services",
    saudiRiyal: "SAR",
    days: "days",
    welcome: "Welcome back",
    createAccount: "Create your account",
    alreadyHave: "Already have an account?",
    dontHave: "Don't have an account?",
    asCustomer: "as Customer",
    asMerchant: "as Merchant",
    feed: "Feed",
    track: "Track",
    requestPosted: "Request posted!",
    offerSent: "Offer sent!",
    offerAccepted: "Offer accepted — contact your merchant.",
    profileSaved: "Profile saved",
    commissionUpdated: "Commission updated",
    contactRevealed: "Customer contact revealed after acceptance",
    onlyAfterAccept: "Customer contact reveals only after you accept an offer.",
    matchingMerchants: "Only merchants matching your city and district will see your request.",
    en: "EN",
    ar: "AR",
    posted: "Posted",
    by: "by",
    viewOffers: "View offers",
    viewDetails: "View details",
    backHome: "Back home",
    youWonOrder: "You won this order! Contact the customer below.",
    pleaseLogin: "Please log in to continue.",
    invalidLogin: "Invalid email or password.",
    selectCity: "Select city",
    selectCategory: "Select category",
    selectAtLeastOne: "Select at least one category",
    photoLabel: "Photo (optional)",
    requirementMet: "✓",
    needApproval: "Account under review",
    alreadyOffered: "You already sent an offer",
    shareWaTitle: "Tell your friends",
    shareWaCta: "Share on WhatsApp",
    shareWaSub: "Help a friend skip the hunt — share your win.",
    shareWaMsg: "I just got my {cat} order on Hustlers KSA in {time} 🚀 — try it: {url}",
    minutes: "minutes",
    hours: "hours",
    days_: "days",
    logo: "Logo",
    customer: "Customer",
    merchant: "Merchant",
    merchantProfile: "Merchant profile",
    analytics: "Analytics",
    yourPerformance: "Your performance",
    insightsSub: "Insights to help you win more orders",
    acceptanceRate: "Acceptance rate",
    decided: "decided",
    avgResponse: "Avg response time",
    requestToOffer: "request → offer",
    totalOffers: "Total offers",
    completedOrders: "Completed orders",
    revenueSar: "Revenue (SAR)",
    commissionPaid: "commission paid",
    ratingLabel: "Rating",
    reviews: "reviews",
    reviewsTitle: "Reviews",
    avgPriceByCat: "Average price by category",
    noAnalyticsData: "No data yet. Send your first offer to see insights.",
    searchRequest: "Search request...",
    searchDescription: "Search description...",
    status: "Status",
    minPrice: "Min price (SAR)",
    maxPrice: "Max price (SAR)",
    sort: "Sort",
    sortNewest: "Newest",
    sortOldest: "Oldest",
    sortPriceAsc: "Price ↑",
    sortPriceDesc: "Price ↓",
    reset: "Reset",
    resetFilters: "Reset filters",
    all: "All",
    dateFrom: "From",
    dateTo: "To",
    featured: "Featured",
    boosted: "Boosted",
    boostThisOffer: "Boost this offer",
    featuredMerchant: "You're a Featured merchant",
    boostOffers: "Boost your offers",
    notifications: "Notifications",
    markRead: "Mark read",
    noNotifications: "No notifications yet.",
    pushOn: "Push notifications on",
    pushEnable: "Enable push notifications",
    pushBlocked: "Blocked in browser settings",
    pushTapDisable: "Tap to disable",
    pushGetNotified: "Get notified when offers arrive",
    pushOffToast: "Push notifications turned off",
    pushOnToast: "Push notifications enabled",
    pushFailed: "Could not update notifications",
    privacyCustomerTitle: "Your privacy is protected",
    privacyCustomerBody: "Merchants will see your request but never your phone or exact address — only the merchant you choose gets your contact.",
    privacyMerchantTitle: "Customer details hidden",
    privacyMerchantBody: "Phone, name and exact address appear only if your offer is accepted.",
    yourReview: "Your review",
    rateMerchant: "Rate the merchant",
    optionalComment: "Optional comment",
    submitReview: "Submit review",
    pickRating: "Please pick a rating",
    thanksReview: "Thanks for your review!",
    suggestedPrice: "Suggested price",
    setYourPrice: "Set your price — no data yet",
    avgAccepted: "Avg accepted in this category",
    customerBudget: "Customer budget",
    useThisPrice: "Use this price",
    aboveBudget: "Above customer's budget",
    nearBudget: "Near the budget ceiling",
    veryCheap: "Looks very cheap — confirm scope",
    competitiveVsBudget: "Competitive vs. budget",
    verified: "Verified",
    noReviews: "No reviews yet",
    memberSince: "Member since",
    twoFactorTitle: "Two-factor sign-in",
    otpSentTo: "We sent a 6-digit code to",
    otpCheckInbox: "Check your inbox for the one-time code (expires in 10 minutes).",
    code: "Code",
    verifySignIn: "Verify & sign in",
    useDifferentAccount: "Use a different account",
    or: "or",
    continueGoogle: "Continue with Google",
    maxImageSize: "Max image size 3MB",
    deliveryPlaceholder: "e.g. 2 days",
    signingIn: "Signing you in…",
    // Landing / premium sections
    howItWorks: "How Hustlers works",
    step1Title: "Create your request",
    step1Desc: "Tell us what you need and add the important details.",
    step2Title: "Receive offers",
    step2Desc: "Trusted local merchants in your city send competitive offers.",
    step3Title: "Pick the best",
    step3Desc: "Compare prices and reviews, then choose what suits you.",
    browseCategories: "Browse categories",
    categoriesBanner: "Home booking, on-site appointment, pickup & delivery, or a custom request based on your details.",
    trustTitle: "Your trust is our priority",
    trustBody: "We are committed to a safe, reliable experience through trusted local businesses and fast support at every step.",
    supportTitle: "We're here to help",
    supportBody: "Our support team is ready to answer all your questions.",
    supportEmail: "support@hustlersksa.com",
    contactSupport: "Contact support",
    trustPoint1: "Trusted businesses",
    trustPoint1Sub: "Real reviews",
    trustPoint2: "Competitive offers",
    trustPoint2Sub: "Pick what suits you",
    trustPoint3: "Simple & easy",
    trustPoint3Sub: "From request to delivery",
    allRights: "All rights reserved",
    whatDoYouNeed: "What do you need today?",
    myRecentRequests: "My recent requests",
    viewAll: "View all",
    // Merchant dashboard
    availableForRequests: "Available for requests",
    notAvailableNow: "Not available now",
    availabilityHint: "When off, new requests won't reach you.",
    availabilityOffFeed: "You're currently unavailable — turn availability on to receive matching requests.",
    coverageTitle: "Coverage area",
    coverageSub: "Choose where you want to receive requests from.",
    fullCity: "Entire city",
    fullCitySub: "Receive requests from all districts",
    specificDistricts: "Specific districts",
    specificDistrictsSub: "Choose the districts you serve",
    selectedDistricts: "Selected districts",
    myCategoriesTitle: "Your service categories",
    myCategoriesSub: "Pick up to 2 categories. You can change them anytime.",
    newRequestsTitle: "New requests",
    newRequestsSub: "Requests waiting for your offer",
    statNewRequests: "New requests",
    statMyOffers: "Offers sent",
    statAccepted: "Accepted",
    statRating: "Rating",
    manageSub: "Manage your requests, offers and services with ease.",
    needHelp: "Need help?",
    supportReady: "Our support team is here for you.",
    // Preview environment + taxonomy update
    vetNotice: "Veterinary services require license verification before activation.",
    otherHomeQuestion: "What home service do you need?",
    otherHomeRequired: "Please tell us what home service you need",
    devicePrivacyNotice: "This service may involve access to your device or data. Your data is handled according to our Privacy Policy.",
    transportDocsNotice: "Commercial transport and delivery activities may require document verification.",
    serviceMethod: "Service method",
    selectServiceMethod: "Select the service method",
    merchantType: "Provider type",
    selectMerchantType: "Select provider type",
    myActivitiesTitle: "Your services",
    myActivitiesSub: "Pick the exact services you provide — only matching requests will reach you",
    selectAtLeastOneActivity: "Select at least one service",
    selectActivitiesPerCategory: "Select at least one service for each category",
    pendingVerification: "Pending license verification",
    docsVerified: "Documents verified",
    viewAllActivities: "View all services",
    showLess: "Show less",
    moreCount: "more",
    loadingLabel: "Loading…",
    upload: "Add photos",
    errorGeneric: "Something went wrong — please try again",
    backLabel: "Back",
    changeLanguage: "Change language",
    removePhoto: "Remove photo",
  },
  ar: {
    appName: "Hustlers KSA",
    slogan1: "Don't Stop the Hustle",
    slogan2: "كل طلب فرصة، وكل عرض بداية.",
    tagline: "اطلب ما تحتاجه من محلات موثوقة في مدينتك",
    sub: "أنشئ طلبك، واستقبل عروضًا من أفضل المحلات المحلية، واختر الأنسب لك بسهولة وراحة.",
    getStarted: "ابدأ الآن",
    iAmCustomer: "أنشئ طلبك",
    iAmMerchant: "انضم كتاجر",
    login: "تسجيل الدخول",
    signup: "إنشاء حساب",
    logout: "تسجيل الخروج",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم الكامل",
    phone: "رقم الجوال",
    businessName: "اسم النشاط",
    whatsapp: "رقم واتساب",
    description: "الوصف",
    city: "المدينة",
    district: "الحي",
    selectDistrict: "اختر الحي",
    category: "الفئة",
    categories: "الفئات",
    activity: "نوع الخدمة",
    selectActivity: "اختر نوع الخدمة",
    activityFree: "اكتب تفاصيل طلبك (اختياري)",
    budget: "الميزانية (ر.س)",
    deadline: "الموعد النهائي",
    photo: "صورة",
    optional: "اختياري",
    submit: "إرسال",
    cancel: "إلغاء",
    save: "حفظ",
    create: "إنشاء",
    createRequest: "طلب جديد",
    newRequest: "أنشئ طلبًا",
    myRequests: "طلباتي",
    receivedOffers: "العروض الواردة",
    noRequests: "لم تنشر أي طلبات بعد.",
    noOffers: "لا توجد عروض بعد — ستظهر هنا قريبًا.",
    noFeed: "لا توجد طلبات مطابقة لنطاق تغطيتك حاليًا.",
    matchedRequests: "الطلبات الجديدة",
    myOffers: "عروضي",
    sendOffer: "إرسال عرض",
    submitOffer: "تقديم عرض",
    accepted: "تم قبول عرض",
    pending: "بانتظار الرد",
    rejected: "لم يتم الاختيار",
    completed: "مكتمل",
    open: "مفتوح",
    sent: "تم إرسال الطلب",
    offers_received: "وصلت عروض",
    expired: "منتهي",
    price: "السعر",
    deliveryTime: "وقت التنفيذ",
    notes: "ملاحظات",
    acceptOffer: "قبول العرض",
    contactWhatsApp: "التواصل عبر واتساب",
    requestDetails: "تفاصيل الطلب",
    pendingApproval: "حسابك قيد المراجعة، وسنعود إليك قريبًا.",
    underReview: "قيد المراجعة",
    admin: "الإدارة",
    dashboard: "لوحة التحكم",
    home: "الرئيسية",
    profile: "الملف",
    customers: "العملاء",
    merchants: "التجار",
    requests: "الطلبات",
    offers: "العروض",
    orders: "الطلبيات",
    commission: "العمولة",
    approve: "اعتماد",
    reject: "رفض",
    markCompleted: "تحديد كمكتمل",
    inProgress: "قيد التنفيذ",
    expectedCommission: "العمولة المتوقعة",
    totalCommission: "إجمالي العمولة",
    rate: "النسبة (%)",
    update: "تحديث",
    selectCategories: "اختر فئات خدماتك",
    maxTwoCategories: "اختر فئتين كحد أقصى لعرض خدماتك",
    saudiRiyal: "ر.س",
    days: "أيام",
    welcome: "أهلًا بعودتك",
    createAccount: "أنشئ حسابك",
    alreadyHave: "لديك حساب بالفعل؟",
    dontHave: "ليس لديك حساب؟",
    asCustomer: "كعميل",
    asMerchant: "كتاجر",
    feed: "الطلبات",
    track: "متابعة",
    requestPosted: "تم إرسال طلبك!",
    offerSent: "تم إرسال العرض!",
    offerAccepted: "تم قبول العرض — تواصل مع التاجر.",
    profileSaved: "تم حفظ الملف",
    commissionUpdated: "تم تحديث العمولة",
    contactRevealed: "ستظهر بيانات التواصل بعد القبول",
    onlyAfterAccept: "بيانات تواصل العميل تظهر بعد قبول العرض فقط.",
    matchingMerchants: "فقط التجار المطابقون لمدينتك وحيّك سيرون طلبك.",
    en: "EN",
    ar: "ع",
    posted: "نُشر",
    by: "بواسطة",
    viewOffers: "عرض العروض",
    viewDetails: "عرض التفاصيل",
    backHome: "العودة",
    youWonOrder: "لقد فزت بهذا الطلب! تواصل مع العميل أدناه.",
    pleaseLogin: "الرجاء تسجيل الدخول للمتابعة.",
    invalidLogin: "بريد إلكتروني أو كلمة مرور غير صحيحة.",
    selectCity: "اختر المدينة",
    selectCategory: "اختر الفئة",
    selectAtLeastOne: "اختر فئة واحدة على الأقل",
    photoLabel: "صورة (اختياري)",
    requirementMet: "✓",
    needApproval: "حسابك قيد المراجعة",
    alreadyOffered: "لقد أرسلت عرضًا بالفعل",
    shareWaTitle: "شارك أصدقاءك",
    shareWaCta: "شارك عبر واتساب",
    shareWaSub: "ساعد صديقك يوفر وقته — شاركه تجربتك.",
    shareWaMsg: "حصلت على طلب {cat} خلال {time} عبر Hustlers KSA 🚀 جرّبها: {url}",
    minutes: "دقيقة",
    hours: "ساعة",
    days_: "يوم",
    logo: "الشعار",
    customer: "عميل",
    merchant: "تاجر",
    merchantProfile: "ملف التاجر",
    analytics: "الإحصائيات",
    yourPerformance: "أداؤك",
    insightsSub: "رؤى تساعدك على كسب المزيد من الطلبات",
    acceptanceRate: "معدل القبول",
    decided: "تم البت فيها",
    avgResponse: "متوسط وقت الاستجابة",
    requestToOffer: "من الطلب إلى العرض",
    totalOffers: "إجمالي العروض",
    completedOrders: "الطلبات المكتملة",
    revenueSar: "الإيرادات (ر.س)",
    commissionPaid: "العمولة المدفوعة",
    ratingLabel: "التقييم",
    reviews: "تقييمات",
    reviewsTitle: "التقييمات",
    avgPriceByCat: "متوسط السعر حسب الفئة",
    noAnalyticsData: "لا توجد بيانات بعد. أرسل عرضك الأول لرؤية الإحصائيات.",
    searchRequest: "ابحث في الطلبات...",
    searchDescription: "ابحث في الوصف...",
    status: "الحالة",
    minPrice: "أقل سعر (ر.س)",
    maxPrice: "أعلى سعر (ر.س)",
    sort: "الترتيب",
    sortNewest: "الأحدث",
    sortOldest: "الأقدم",
    sortPriceAsc: "السعر ↑",
    sortPriceDesc: "السعر ↓",
    reset: "إعادة تعيين",
    resetFilters: "إعادة تعيين الفلاتر",
    all: "الكل",
    dateFrom: "من",
    dateTo: "إلى",
    featured: "مميز",
    boosted: "معزّز",
    boostThisOffer: "عزّز هذا العرض",
    featuredMerchant: "أنت تاجر مميز",
    boostOffers: "عزّز عروضك",
    notifications: "الإشعارات",
    markRead: "تحديد كمقروء",
    noNotifications: "لا توجد إشعارات بعد.",
    pushOn: "إشعارات الجوال مفعّلة",
    pushEnable: "تفعيل إشعارات الجوال",
    pushBlocked: "محظورة في إعدادات المتصفح",
    pushTapDisable: "اضغط للتعطيل",
    pushGetNotified: "احصل على إشعار عند وصول العروض",
    pushOffToast: "تم إيقاف الإشعارات",
    pushOnToast: "تم تفعيل الإشعارات",
    pushFailed: "تعذر تحديث الإشعارات",
    privacyCustomerTitle: "خصوصيتك محمية",
    privacyCustomerBody: "سيرى التجار طلبك لكن لن يروا رقمك أو عنوانك الدقيق — فقط التاجر الذي تختاره يحصل على بيانات تواصلك.",
    privacyMerchantTitle: "بيانات العميل مخفية",
    privacyMerchantBody: "يظهر الاسم والجوال والعنوان الدقيق فقط عند قبول عرضك.",
    yourReview: "تقييمك",
    rateMerchant: "قيّم التاجر",
    optionalComment: "تعليق اختياري",
    submitReview: "إرسال التقييم",
    pickRating: "الرجاء اختيار تقييم",
    thanksReview: "شكرًا لتقييمك!",
    suggestedPrice: "السعر المقترح",
    setYourPrice: "حدد سعرك — لا توجد بيانات بعد",
    avgAccepted: "متوسط المقبول في هذه الفئة",
    customerBudget: "ميزانية العميل",
    useThisPrice: "استخدم هذا السعر",
    aboveBudget: "أعلى من ميزانية العميل",
    nearBudget: "قريب من سقف الميزانية",
    veryCheap: "يبدو رخيصًا جدًا — تأكد من نطاق العمل",
    competitiveVsBudget: "سعر تنافسي مقارنة بالميزانية",
    verified: "موثّق",
    noReviews: "لا توجد تقييمات بعد",
    memberSince: "عضو منذ",
    twoFactorTitle: "التحقق بخطوتين",
    otpSentTo: "أرسلنا رمزًا من ٦ أرقام إلى",
    otpCheckInbox: "تحقق من بريدك الوارد للحصول على الرمز — تنتهي صلاحيته خلال ١٠ دقائق.",
    code: "الرمز",
    verifySignIn: "تحقق وسجّل الدخول",
    useDifferentAccount: "استخدام حساب آخر",
    or: "أو",
    continueGoogle: "المتابعة عبر Google",
    maxImageSize: "الحد الأقصى لحجم الصورة ٣ ميجابايت",
    deliveryPlaceholder: "مثال: يومان",
    signingIn: "جارٍ تسجيل دخولك…",
    // Landing / premium sections
    howItWorks: "كيف تعمل هاستلرز؟",
    step1Title: "أنشئ طلبك",
    step1Desc: "أخبرنا بما تحتاجه وأضف التفاصيل المهمة.",
    step2Title: "استقبل العروض",
    step2Desc: "ستتلقى عروضًا تنافسية من محلات موثوقة في مدينتك.",
    step3Title: "اختر الأنسب لك",
    step3Desc: "قارن بين العروض وآراء العملاء واختر ما يناسبك.",
    browseCategories: "تصفح التصنيفات",
    categoriesBanner: "حجز منزلي، موعد في الموقع، استلام وتسليم، أو طلب مخصص حسب التفاصيل.",
    trustTitle: "ثقتك أولويتنا",
    trustBody: "نحرص على تقديم تجربة آمنة وموثوقة من خلال محلات محلية موثوقة ودعم سريع في كل خطوة.",
    supportTitle: "نحن هنا لمساعدتك",
    supportBody: "فريق الدعم جاهز للرد على جميع استفساراتك.",
    supportEmail: "support@hustlersksa.com",
    contactSupport: "تواصل مع الدعم",
    trustPoint1: "محلات موثوقة",
    trustPoint1Sub: "تقييمات حقيقية",
    trustPoint2: "عروض تنافسية",
    trustPoint2Sub: "اختر الأنسب لك",
    trustPoint3: "سهولة وراحة",
    trustPoint3Sub: "من الطلب حتى الاستلام",
    allRights: "جميع الحقوق محفوظة",
    whatDoYouNeed: "ماذا تحتاج اليوم؟",
    myRecentRequests: "طلباتي الأخيرة",
    viewAll: "عرض الكل",
    // Merchant dashboard
    availableForRequests: "متاح لاستقبال الطلبات",
    notAvailableNow: "غير متاح حاليًا",
    availabilityHint: "عند الإيقاف، لن تصلك طلبات جديدة.",
    availabilityOffFeed: "أنت غير متاح حاليًا — فعّل الاستقبال لتصلك الطلبات المطابقة.",
    coverageTitle: "نطاق التغطية",
    coverageSub: "اختر نطاق التغطية الذي ترغب باستقبال الطلبات منه.",
    fullCity: "كامل المدينة",
    fullCitySub: "استقبال الطلبات من جميع أحياء المدينة",
    specificDistricts: "أحياء محددة",
    specificDistrictsSub: "اختر الأحياء التي ترغب باستقبال الطلبات منها",
    selectedDistricts: "الأحياء المحددة",
    myCategoriesTitle: "فئات خدماتك",
    myCategoriesSub: "اختر فئتين كحد أقصى لعرض خدماتك. يمكنك تعديل الفئات في أي وقت.",
    newRequestsTitle: "الطلبات الجديدة",
    newRequestsSub: "طلبات جديدة تحتاج إلى عروض منك",
    statNewRequests: "الطلبات الجديدة",
    statMyOffers: "العروض المقدمة",
    statAccepted: "المقبولة",
    statRating: "التقييم العام",
    manageSub: "إدارة طلباتك وعروضك وخدماتك بكل سهولة.",
    needHelp: "تحتاج مساعدة؟",
    supportReady: "فريق الدعم متاح لمساعدتك.",
    // Preview environment + taxonomy update
    vetNotice: "تتطلب الخدمات البيطرية التحقق من الترخيص قبل تفعيلها.",
    otherHomeQuestion: "ما الخدمة المنزلية التي تحتاجها؟",
    otherHomeRequired: "يرجى كتابة الخدمة المنزلية التي تحتاجها",
    devicePrivacyNotice: "قد تتضمن هذه الخدمة الوصول إلى جهازك أو بياناتك، وتُعامل بياناتك وفق سياسة الخصوصية.",
    transportDocsNotice: "قد تتطلب أنشطة النقل والتوصيل التجارية توثيق المستندات.",
    serviceMethod: "طريقة تقديم الخدمة",
    selectServiceMethod: "اختر طريقة تقديم الخدمة",
    merchantType: "نوع مزود الخدمة",
    selectMerchantType: "اختر نوع مزود الخدمة",
    myActivitiesTitle: "خدماتك",
    myActivitiesSub: "حدد الخدمات التي تقدمها بدقة، لتصلك الطلبات المطابقة فقط",
    selectAtLeastOneActivity: "اختر خدمة واحدة على الأقل",
    selectActivitiesPerCategory: "اختر خدمة واحدة على الأقل لكل فئة",
    pendingVerification: "بانتظار توثيق الترخيص",
    docsVerified: "المستندات موثقة",
    viewAllActivities: "عرض جميع الخدمات",
    showLess: "عرض أقل",
    moreCount: "أخرى",
    loadingLabel: "جارٍ التحميل…",
    upload: "أضف صورًا",
    errorGeneric: "حدث خطأ ما، حاول مرة أخرى",
    backLabel: "رجوع",
    changeLanguage: "تغيير اللغة",
    removePhoto: "إزالة الصورة",
  },
};

// ---- Category & city labels (approved taxonomy) ----
const CAT_LABELS = {
  en: {
    flowers_gifts: "Flowers & Gifts",
    events_photography: "Events & Photography",
    home_services: "Home Services",
    car_services: "Car Services",
    pets: "Pet Services",
    beauty_care: "Beauty & Personal Care",
    lessons_training: "Lessons & Training",
    phones_electronics: "Phone & Electronics Repair",
    custom_requests: "Custom Requests",
    moving_transport: "Moving & Freight",
  },
  ar: {
    flowers_gifts: "زهور وهدايا",
    events_photography: "مناسبات وتصوير",
    home_services: "خدمات منزلية",
    car_services: "خدمات السيارات",
    pets: "خدمات الحيوانات الأليفة",
    beauty_care: "جمال وعناية شخصية",
    lessons_training: "دروس وتدريب",
    phones_electronics: "صيانة الجوالات والإلكترونيات",
    custom_requests: "طلبات مخصصة",
    moving_transport: "نقل وشحن",
  },
};

// Activities are stored in Arabic (canonical). English display mapping covers
// every full activity, homepage grouping label, service method and provider type.
const ACT_LABELS_EN = {
  // Home services
  "صيانة وتركيب المكيفات": "AC installation & maintenance",
  "تنظيف وغسيل المكيفات": "AC cleaning & washing",
  "سباكة": "Plumbing",
  "كهرباء منازل": "Home electrical",
  "صيانة أجهزة منزلية": "Home appliance repair",
  "صيانة ثلاجات وفريزرات": "Fridge & freezer repair",
  "صيانة غسالات ونشافات": "Washer & dryer repair",
  "صيانة أفران وطباخات": "Oven & stove repair",
  "تنظيف منازل": "Home cleaning",
  "تنظيف عميق": "Deep cleaning",
  "تنظيف كنب وسجاد": "Sofa & carpet cleaning",
  "تنظيف خزانات مياه": "Water tank cleaning",
  "مكافحة حشرات": "Pest control",
  "كشف تسربات المياه": "Water leak detection",
  "نجارة وتركيب أثاث": "Carpentry & furniture assembly",
  "تركيب أجهزة منزلية": "Appliance installation",
  "دهان وورق جدران": "Painting & wallpaper",
  "جبس وديكور داخلي": "Gypsum & interior decor",
  "تركيب ستائر": "Curtain installation",
  "حدادة وألمنيوم": "Metalwork & aluminum",
  "تركيب زجاج ومرايا": "Glass & mirror installation",
  "تنسيق وصيانة الحدائق": "Garden landscaping & care",
  "صيانة عامة": "General maintenance",
  "خدمات منزلية أخرى": "Other Home Services",
  // Car services
  "بنشر متنقل": "Mobile tire service",
  "إصلاح وتغيير الإطارات": "Tire repair & replacement",
  "بطاريات متنقلة": "Mobile battery service",
  "اشتراك وتشغيل البطارية": "Battery jump-start",
  "تغيير الزيت والفلاتر": "Oil & filter change",
  "فحص وتشخيص الأعطال": "Fault diagnostics",
  "فحص كمبيوتر السيارات": "Car computer scan",
  "ميكانيكا سيارات": "Car mechanics",
  "كهرباء سيارات": "Auto electrical",
  "صيانة تكييف السيارات": "Car AC service",
  "غسيل سيارات": "Car wash",
  "تلميع وتنظيف داخلي": "Interior detailing",
  "حماية وتلميع الطلاء": "Paint protection & polishing",
  "تظليل سيارات": "Window tinting",
  "سمكرة ودهان": "Bodywork & paint",
  "سطحة وسحب سيارات": "Towing & recovery",
  "برمجة مفاتيح السيارات": "Car key programming",
  "تركيب إكسسوارات السيارات": "Car accessory installation",
  "فحص السيارة قبل الشراء": "Pre-purchase inspection",
  // Beauty & personal care
  "مكياج": "Makeup",
  "مكياج مناسبات": "Occasion makeup",
  "تجهيز العرائس": "Bridal styling",
  "تصفيف وتسريحات الشعر": "Hair styling",
  "قص الشعر": "Haircut",
  "صبغات وتلوين الشعر": "Hair coloring",
  "علاجات الشعر": "Hair treatments",
  "استشوار": "Blowout",
  "مانيكير": "Manicure",
  "باديكير": "Pedicure",
  "جل وأكريليك للأظافر": "Gel & acrylic nails",
  "تصميم وزينة الأظافر": "Nail art",
  "تركيب رموش": "Lash extensions",
  "رفع الرموش": "Lash lift",
  "تنسيق وصبغ الحواجب": "Brow shaping & tinting",
  "عناية وتنظيف البشرة": "Skincare & facial cleansing",
  "إزالة الشعر": "Hair removal",
  "حناء ونقش": "Henna art",
  "مساج واسترخاء غير طبي": "Non-medical massage & relaxation",
  "مانيكير وباديكير": "Manicure & pedicure",
  "رموش وحواجب": "Lashes & brows",
  "عناية بالبشرة": "Skincare",
  // Events & photography
  "تصوير مناسبات": "Event photography",
  "تصوير حفلات زفاف": "Wedding photography",
  "تصوير منتجات": "Product photography",
  "تصوير فيديو": "Videography",
  "مونتاج فيديو": "Video editing",
  "تنسيق وإدارة المناسبات": "Event planning & management",
  "ديكور وتجهيز المناسبات": "Event decor & setup",
  "تجهيز كوش الأفراح": "Wedding stage setup",
  "تنسيق بالونات": "Balloon styling",
  "ضيافة قهوة وشاي": "Coffee & tea hospitality",
  "قهوجيون وصبابون": "Traditional coffee servers",
  "بوفيه وضيافة": "Buffet & catering",
  "صوت وإضاءة": "Sound & lighting",
  "تأجير طاولات وكراسي": "Table & chair rental",
  "تأجير مستلزمات المناسبات": "Event equipment rental",
  "دي جي وترفيه للمناسبات": "DJ & entertainment",
  "بث مباشر للمناسبات": "Event live streaming",
  "طباعة دعوات ولوحات": "Invitation & signage printing",
  "تنسيق مناسبات": "Event planning",
  "ديكور وتجهيز": "Decor & setup",
  // Flowers & gifts
  "باقات زهور": "Flower bouquets",
  "تنسيق زهور": "Flower arrangement",
  "زهور في مزهريات": "Vase arrangements",
  "زهور للمناسبات": "Event flowers",
  "بوكسات هدايا جاهزة": "Ready gift boxes",
  "تجهيز بوكس هدايا حسب المناسبة": "Custom occasion gift boxes",
  "تغليف هدايا": "Gift wrapping",
  "شوكولاتة وحلويات": "Chocolate & sweets",
  "كيك وحلويات للمناسبات": "Occasion cakes & sweets",
  "عطور": "Perfumes",
  "بخور وفواحات": "Incense & diffusers",
  "شموع": "Candles",
  "نباتات وهدايا نباتية": "Plants & plant gifts",
  "هدايا مواليد": "Newborn gifts",
  "هدايا تخرج": "Graduation gifts",
  "هدايا شركات": "Corporate gifts",
  "بوكسات هدايا": "Gift boxes",
  // Phones & electronics
  "صيانة جوالات": "Phone repair",
  "استبدال شاشات الجوال": "Phone screen replacement",
  "استبدال بطاريات الجوال": "Phone battery replacement",
  "إصلاح منافذ الشحن": "Charging port repair",
  "إصلاح الكاميرا والسماعة": "Camera & speaker repair",
  "استعادة بيانات الجوال": "Phone data recovery",
  "صيانة الأجهزة اللوحية": "Tablet repair",
  "صيانة أجهزة الحاسب المكتبي": "Desktop computer repair",
  "صيانة اللابتوب": "Laptop repair",
  "تثبيت الأنظمة والبرامج": "OS & software installation",
  "إزالة الفيروسات والبرامج الضارة": "Virus & malware removal",
  "استعادة البيانات": "Data recovery",
  "صيانة أجهزة الألعاب": "Game console repair",
  "صيانة التلفزيونات والشاشات": "TV & monitor repair",
  "صيانة الكاميرات": "Camera repair",
  "إعداد الشبكات والواي فاي": "Network & Wi-Fi setup",
  "تركيب كاميرات المراقبة": "CCTV installation",
  "تركيب أنظمة المنزل الذكي": "Smart home setup",
  "صيانة أجهزة الحاسب واللابتوب": "Computer & laptop repair",
  // Moving & freight
  "نقل أثاث": "Furniture moving",
  "فك وتركيب الأثاث": "Furniture disassembly & assembly",
  "تغليف الأثاث": "Furniture packing",
  "نقل المكاتب والشركات": "Office & business relocation",
  "نقل الأجهزة والمعدات": "Equipment transport",
  "نقل البضائع": "Goods transport",
  "توصيل داخل المدينة": "In-city delivery",
  "شحن بين المدن": "Intercity freight",
  "نقل مبرد": "Refrigerated transport",
  "تخزين مؤقت": "Temporary storage",
  "توصيل طلبات المتاجر": "Store order delivery",
  "نقل الدراجات النارية": "Motorcycle transport",
  "نقل السيارات": "Car transport",
  "نقل بضائع": "Goods transport",
  // Lessons & training
  "دروس المرحلة الابتدائية": "Elementary school tutoring",
  "دروس المرحلة المتوسطة": "Middle school tutoring",
  "دروس المرحلة الثانوية": "High school tutoring",
  "التحضير لاختبار القدرات": "Qudurat test prep",
  "التحضير للاختبار التحصيلي": "Tahsili test prep",
  "تعليم اللغة الإنجليزية": "English lessons",
  "تعليم اللغة العربية": "Arabic lessons",
  "تعليم لغات أخرى": "Other language lessons",
  "التحضير لاختبار IELTS": "IELTS prep",
  "التحضير لاختبار TOEFL": "TOEFL prep",
  "دروس جامعية": "University tutoring",
  "مساعدة في الواجبات": "Homework help",
  "تعليم الحاسب": "Computer skills",
  "برمجة للمبتدئين": "Beginner programming",
  "دروس موسيقى": "Music lessons",
  "تدريب رياضي شخصي": "Personal fitness training",
  "تدريب مهني ومهاري": "Vocational & skills training",
  "تدريب عن بُعد": "Remote training",
  "دروس مدرسية": "School tutoring",
  "قدرات وتحصيلي": "Qudurat & Tahsili prep",
  "تعليم اللغات": "Language lessons",
  // Custom requests
  "كيك حسب الطلب": "Custom cakes",
  "حلويات حسب الطلب": "Custom sweets",
  "هدايا مخصصة": "Custom gifts",
  "بوكسات مخصصة": "Custom boxes",
  "توزيعات مخصصة": "Custom giveaways",
  "طباعة حسب الطلب": "Custom printing",
  "طباعة الملابس": "Apparel printing",
  "طباعة الأكواب والمنتجات": "Mug & product printing",
  "تطريز حسب الطلب": "Custom embroidery",
  "حفر ونقش بالليزر": "Laser engraving",
  "تصميم وطباعة الدعوات": "Invitation design & printing",
  "بطاقات مخصصة": "Custom cards",
  "لوحات ولافتات": "Signs & banners",
  "استيكرات وملصقات": "Stickers & labels",
  "تغليف وتعبئة مخصصة": "Custom packaging",
  "تصميم جرافيك": "Graphic design",
  "مجسمات ومنتجات يدوية": "Handmade crafts & models",
  "نجارة حسب الطلب": "Custom woodwork",
  "تفصيل الستائر والمفروشات": "Custom curtains & upholstery",
  // Pet services
  "عناية وتجميل الحيوانات الأليفة": "Pet grooming",
  "استحمام وتنظيف الحيوانات الأليفة": "Pet bathing & cleaning",
  "قص الشعر والأظافر": "Fur & nail trimming",
  "استضافة الحيوانات الأليفة": "Pet boarding",
  "حضانة نهارية للحيوانات الأليفة": "Pet daycare",
  "رعاية منزلية للحيوانات الأليفة": "In-home pet care",
  "زيارة ورعاية الحيوانات أثناء السفر": "Pet sitting while you travel",
  "تمشية الكلاب": "Dog walking",
  "تدريب الحيوانات الأليفة": "Pet training",
  "نقل الحيوانات الأليفة": "Pet transport",
  "خدمات بيطرية": "Veterinary services",
  "تطعيمات وفحوصات بيطرية": "Vaccinations & vet checkups",
  "مستلزمات الحيوانات الأليفة": "Pet supplies",
  "عناية وتجميل الحيوانات": "Pet grooming",
  "استضافة الحيوانات": "Pet boarding",
  "رعاية منزلية": "In-home care",
  // Service methods
  "في موقع العميل": "At the customer's location",
  "في موقع مزود الخدمة": "At the provider's location",
  "استلام وتسليم": "Pickup & delivery",
  "عن بُعد": "Remote",
  "حسب الاتفاق": "As agreed",
  // Provider types
  "فرد مستقل": "Independent individual",
  "مؤسسة": "Establishment",
  "شركة": "Company",
  "متجر": "Store",
  "صالون": "Salon",
  "عيادة": "Clinic",
  "مركز تدريب": "Training center",
};

const CITY_LABELS = {
  en: { riyadh: "Riyadh", jeddah: "Jeddah", dammam: "Dammam", khobar: "Khobar", makkah: "Makkah", madinah: "Madinah", other: "Other" },
  ar: { riyadh: "الرياض", jeddah: "جدة", dammam: "الدمام", khobar: "الخبر", makkah: "مكة", madinah: "المدينة", other: "أخرى" },
};

const LangCtx = createContext({ lang: "en", t: (k) => k, setLang: () => {}, dir: "ltr" });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("hk_lang") || "ar");
  const dir = lang === "ar" ? "rtl" : "ltr";

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
  }, [lang, dir]);

  const setLang = (l) => {
    localStorage.setItem("hk_lang", l);
    setLangState(l);
  };

  const t = (k) => (dict[lang] && dict[lang][k]) || dict.en[k] || k;
  const tCat = (key) => CAT_LABELS[lang]?.[key] || key;
  const tCity = (key) => CITY_LABELS[lang]?.[key] || key;
  const tAct = (act) => (lang === "en" ? ACT_LABELS_EN[act] || act : act);

  return (
    <LangCtx.Provider value={{ lang, setLang, t, tCat, tCity, tAct, dir }}>
      {children}
    </LangCtx.Provider>
  );
}

export const useLang = () => useContext(LangCtx);
